import axios, {originalAxios} from '@/axios-service';
import { ResponseContent, responseContent } from '../types';
import { FarmAnalysisResult, ScoreHistogramDTO, AreaHistogramDTO, HarvestResultTableDTO } from './types';
import { classToPlain } from 'class-transformer';

const MS_URL = 'senana/api/result';
const V2_URL = 'senana/api/v2/result';
const asFarmAnalysisResult = responseContent(FarmAnalysisResult);
const asHistogramDTO = responseContent(ScoreHistogramDTO);
const asAreaHistogramDTO = responseContent(AreaHistogramDTO);
const harvestResultResponseTableDTO = responseContent(HarvestResultTableDTO);

export const getFarmAnalysisResult = async (farmAnalysisUuid: string, harvestSeason: string, cropType: string): Promise<ResponseContent<FarmAnalysisResult>> => axios
  .get(`${MS_URL}/${farmAnalysisUuid}`, { params: { harvestSeason, cropType }})
  .then(asFarmAnalysisResult);


export const getFarmAnalysisResultList = async (farmAnalysisUuid: string, harvestSeason: string): Promise<ResponseContent<FarmAnalysisResult[]>> => axios
  .get(`${V2_URL}/${farmAnalysisUuid}`, { params: { harvestSeason }})
  .then(asFarmAnalysisResult);


export const downloadGeoJson = (url: string): Promise<GeoJSON.GeoJSON> => originalAxios
  .get(url)
  .then(it => it.data);

export const findScoreHistogramByCropTypeAnalysisYear = (analysisYear: number| undefined, cropType: string, onlyUserOwners: boolean,
  harvestSeason: string): Promise<ResponseContent<ScoreHistogramDTO[]>> => axios
.get(`${MS_URL}/score-histogram`, { params: { analysisYear, cropType, onlyUserOwners, harvestSeason }})
.then(asHistogramDTO);

export const findAreaHistogramByCropTypeAnalysisYear = (analysisYear: number| undefined, cropType: string, onlyUserOwners: boolean,
  harvestSeason: string): Promise<ResponseContent<AreaHistogramDTO[]>> => axios
.get(`${MS_URL}/area-histogram`, { params: { analysisYear, cropType, onlyUserOwners, harvestSeason }})
.then(asAreaHistogramDTO);


export const getHarvestResult = async (uuid: string, harvestSeason: string, cropType: string) => axios
.get(`${MS_URL}/analysis/${uuid}`, { params: { harvestSeason, cropType }})
.then(harvestResultResponseTableDTO);
